import React, { useContext, useEffect, useState } from "react";
import { Context as AuthContext } from "../../context/AuthContext";
import {
  FormControl,
  TextField,
  Button,
  Container,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import styles from "./index.module.scss";
import { generateOTP } from "./loginApi";
import { useHistory, useLocation } from "react-router-dom";
import ModalComponent from "../../components/AlertComponent/modal";
import {
  handleTypeNumber,
  checkMobileNumber,
  OTPValidation,
} from "../../utils/validation";

const LoginPage = (props) => {
  const [userDetails, setUserDetails] = useState({
    mobileNo: null,
    otp: null,
  });
  const [errorMsg, setErrorMsg] = useState({
    mobileNo: null,
    otp: null,
  });
  const [disableBtn, setDisableBtn] = useState(true);
  const [showOtpBtn, setShowOtpBtn] = useState(false);
  const { signin } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [errorToDisplay, setErrorToDisplay] = useState({
    msg: null,
    title: null,
    btn1: null,
    btn2: null,
    btn1Handle: null,
    path: null,
  });
  const [disableLogin, setDisableLogin] = useState(true);
  const [timeLeft, setTimeLeft] = useState();
  const [startTimer, setStartTimer] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false);
  const [loginLoader, setLoginLoader] = useState(false);

  let history = useHistory();
  let location = useLocation();
  let intervalId;

  useEffect(() => {
    if (!timeLeft) {
      setShowResend(true);
      clearInterval(intervalId);
      // setDisableBtn(true);
    } else {
      setShowResend(false);
      intervalId = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  //function to handle input change
  const inputChange = (e) => {
    let obj = { ...userDetails };
    let msg = { ...errorMsg };
    obj[e.target.name] = e.target.value;
    msg[e.target.name] = null;
    setErrorMsg(msg);
    if (e.target.name === "mobileNo") {
      e.target.value.length === 10 ? setDisableBtn(false) : setDisableBtn(true);
    }
    if (e.target.name === "otp") {
      e.target.value.length === 6
        ? setDisableLogin(false)
        : setDisableLogin(true);
    }
    setUserDetails(obj);
  };

  //function to handle input validation
  const checkValidation = (e) => {
    let msg = { ...errorMsg };
    if (e.target.name === "mobileNo") {
      let result = checkMobileNumber(e.target.value);
      if (result) {
        msg[e.target.name] = result;
      } else {
        msg[e.target.name] = null;
      }
    } else if (e.target.name === "otp") {
      let result = OTPValidation(e.target.value);
      if (result) {
        msg[e.target.name] = result;
      } else {
        msg[e.target.name] = null;
      }
    }
    setErrorMsg(msg);
  };

  //function to validate mobile number
  const checkMobileValidations = (type, callback) => {
    let phoneno = /^\d{10}$/;
    let msg = { ...errorMsg };
    if (type === "mobileNo" || type === "all") {
      if (!userDetails.mobileNo) {
        msg.mobileNo = "Mobile Number is required";
        setDisableBtn(true);
        setErrorMsg(msg);
      } else if (!userDetails.mobileNo.match(phoneno)) {
        msg.mobileNo = "Enter valid Mobile Number";
        setDisableBtn(true);
        setErrorMsg(msg);
      } else {
        msg.mobileNo = null;
        setDisableBtn(false);
        setErrorMsg(msg);
        return callback ? callback(type) : null;
      }
    }
  };

  //function to send otp
  const sendOtp = async () => {
    setOtpLoader(true);
    let data = { username: userDetails.mobileNo, isWoSeller: true };
    await generateOTP(data.username, data.isWoSeller)
      .then((res) => {
        if (res && res.data.status === "success") {
          if (res.data.reg_status === "wo_seller_unregistered") {
            let error = { ...errorToDisplay };
            error.msg =
              "Looks like you are not registered with us. Please check your mobile number and try again or create an account.";
            error.title = "Error";
            error.btn1 = "Cancel";
            error.btn2 = "Create Account";
            error.path = "/signUp";
            setErrorToDisplay(error);
            setShowModal(true);
            setOtpLoader(false);
          } else if (res.data.reg_status === "wo_seller_pending") {
            localStorage.setItem("requestId", res.data.request_id);
            let error = { ...errorToDisplay };
            error.msg =
              "Looks like you have already created an account. Procced with registration.";
            error.title = "";
            error.btn1 = "Cancel";
            error.btn2 = "Okay";
            error.path = "/registration";
            setErrorToDisplay(error);
            setShowModal(true);
            setOtpLoader(false);
          } else if (res.data.reg_status === "wo_seller_requested") {
            let error = { ...errorToDisplay };
            error.msg =
              "Your account is under review. We will notify you, once your application is approved.";
            error.title = "";
            error.btn1 = "";
            error.btn2 = "Okay";
            error.path = "close";
            setErrorToDisplay(error);
            setShowModal(true);
            setOtpLoader(false);
          } else if (!res.data.reg_status) {
            setShowOtpBtn(true);
            setStartTimer(true);
            setTimeLeft(30);
            setOtpLoader(false);
          }
        } else {
          let error = { ...errorToDisplay };
          error.msg = res.data.msg;
          error.title = "Error";
          setErrorToDisplay(error);
          setShowModal(true);
          setDisableBtn(false);
          setOtpLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setDisableBtn(false);
        setOtpLoader(false);
      });
  };

  //function to login
  const login = async () => {
    setLoginLoader(true);
    let username = userDetails.mobileNo;
    let otp = userDetails.otp;
    let isWoSeller = true;
    let { from } = location.state || { from: { pathname: "/" } };
    const signInResp = await signin({ username, otp, isWoSeller });
    if (signInResp === "success") {
      setLoginLoader(false);
      history.replace(from);
    } else {
      setLoginLoader(false);
      let error = { ...errorToDisplay };
      // error.msg = 'Error while logging in. Please try after someime';
      error.msg = signInResp.data.msg;
      error.title = "Error";
      error.btn1 = "";
      error.btn2 = "Okay";
      error.path = "close";
      setErrorToDisplay(error);
      setShowModal(true);
      setDisableBtn(false);
    }
  };

  //function to handle modal close
  const handleModalClose = () => {
    setShowModal(false);
  };

  //function to check form validation
  const checkFormValidation = () => {
    if (
      errorMsg.mobileNo ||
      !userDetails.mobileNo ||
      errorMsg.otp ||
      !userDetails.otp
    ) {
      return false;
    } else return true;
  };

  //function to handle modal actions
  const handleBtn2Fnc = () => {
    if (errorToDisplay.path === "close") {
      handleModalClose();
    } else {
      props.history.replace({ pathname: errorToDisplay.path });
    }
  };

  return (
    <div>
      <ModalComponent
        msg={errorToDisplay.msg}
        title={errorToDisplay.title}
        btn1Text={errorToDisplay.btn1}
        btn2Text={errorToDisplay.btn2}
        show={showModal}
        handleBtn1={handleModalClose}
        handleBtn2={handleBtn2Fnc}
        handleModalClose={handleModalClose}
      />
      <Container id={styles.wrapper} maxWidth="sm">
        <Paper elevation={3} id={styles.loginWrapper}>
          <div className="d-flex justify-content-center">
            <img src="/images/GoStor_main.svg" width="140px" height="auto" />
          </div>
          {/* <h5 className="text-center mt-4">Login to GoStor Seller</h5> */}
          <div className={styles.container}>
            <FormControl fullWidth>
              <TextField
                required
                type="number"
                name="mobileNo"
                id="mobileNo"
                label="Enter Mobile Number"
                autoComplete="off"
                error={errorMsg.mobileNo ? true : false}
                helperText={errorMsg.mobileNo}
                onKeyDown={(evt) => handleTypeNumber(evt)}
                value={userDetails.mobileNo || ""}
                onChange={(e) => inputChange(e)}
                onBlur={(e) => checkValidation(e)}
              />
              {showOtpBtn ? (
                <React.Fragment>
                  <TextField
                    className="mt-3"
                    required
                    type="number"
                    autoComplete="off"
                    name="otp"
                    id="otp"
                    label="Enter OTP"
                    error={errorMsg.otp ? true : false}
                    helperText={errorMsg.otp}
                    value={userDetails.otp || ""}
                    onChange={(e) => inputChange(e)}
                    onBlur={(e) => checkValidation(e)}
                  />
                  {!showResend ? (
                    <small className="text-muted text-right">
                      Resend OTP in {timeLeft} seconds{" "}
                    </small>
                  ) : null}
                  {showResend && timeLeft <= 0 ? (
                    <div className="d-flex justify-content-end">
                      <button
                        className={`${styles.resendBtn} p-1`}
                        onClick={() =>
                          !otpLoader
                            ? checkMobileValidations("mobileNo", sendOtp)
                            : null
                        }
                      >
                        Resend OTP
                        {otpLoader ? (
                          <CircularProgress className="ml-2" size={15} />
                        ) : null}
                      </button>
                    </div>
                  ) : null}
                </React.Fragment>
              ) : null}
            </FormControl>
            <div className={styles.btnContainer}>
              {!showOtpBtn ? (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={disableBtn || otpLoader}
                  className={`${
                    disableBtn || otpLoader ? styles.disableBtn : null
                  } ${styles.btnComp}`}
                  onClick={(e) =>
                    !disableBtn && !otpLoader ? sendOtp() : null
                  }
                >
                  Generate OTP
                  {otpLoader ? (
                    <CircularProgress
                      style={{ color: "white" }}
                      className="ml-2"
                      size={15}
                    />
                  ) : null}
                </Button>
              ) : null}
              {showOtpBtn ? (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={
                    !checkFormValidation() || disableLogin || loginLoader
                  }
                  className={`${
                    !checkFormValidation() || disableLogin || loginLoader
                      ? styles.disableBtn
                      : null
                  } ${styles.btnComp}`}
                  onClick={(e) =>
                    checkFormValidation() && !disableLogin && !loginLoader
                      ? login()
                      : null
                  }
                >
                  Login
                  {loginLoader ? (
                    <CircularProgress
                      style={{ color: "white" }}
                      className="ml-2"
                      size={15}
                    />
                  ) : null}
                </Button>
              ) : null}
            </div>
          </div>
          <div className={styles.bottomText}>
            <h6>
              Not yet registered?
              <span
                id={styles.createBtn}
                onClick={() => props.history.push("/signUp")}
              >
                {" "}
                Create account
              </span>{" "}
            </h6>
          </div>
        </Paper>
      </Container>
    </div>
  );
};

export default LoginPage;
